/* eslint-disable no-case-declarations */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getShop } from '../../../../common/pageData';
import {
  ADD_TO_CART,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_ERROR,
  ADD_TO_CART_API,
  SET_ATC_STATUS_ADDING,
} from '../constants';
import { logger } from '../../../../common/logger';
import { StaticMutexKeys, mutexManager } from '../../../../common/mutexmanager';

function* addToCartWorker(action) {
  // as parallel modification of cart results in inconsistent data, adding mutex
  const shopifyCartMutex = mutexManager.getMutex(StaticMutexKeys.CART_MODIFY);
  try {
    yield call([shopifyCartMutex, 'acquire']);
    const formData = {
      quantity: 1,
      id: action.variant.id,
      properties: action.properties,
    };

    yield put({
      type: SET_ATC_STATUS_ADDING,
      ...{
        spVariantID: formData.id,
        widgetID: action.widgetID,
      },
    });

    if (
      getShop() === 'orderflow-labs.myshopify.com' &&
      action.variant.id === 42984940732630
    ) {
      formData.selling_plan = 3052241110;
    }

    if (action.variant.id === 50587593113873) {
      logger.log('Adding selling plan for variant 50587593113873');
      formData.selling_plan = 12224135441;
    }

    const httpArgs = [ADD_TO_CART_API, formData];
    const { data, status } = yield call(axios.post, ...httpArgs);

    if (status === 200) {
      yield put({
        type: ADD_TO_CART_SUCCESS,
        datapack: {
          ...data,
          mrOfferID: action.mrOfferID,
          isEmbedded: action.isEmbedded,
          isProductPage: action.isProductPage,
          primary: action.primary,
          variantsWithQuantity: action.variantsWithQuantity,
          isBottomBarButtonActionGoToCart:
            action.isBottomBarButtonActionGoToCart,
          theme: action.theme,
          discountCode: action.discountCode,
          offerType: action.offerType,
          product_id: action.productId,
          variant_id: action.variantId,
          product_title: action.productTitle,
          variant_title: action.variantTitle,
          widgetID: action.widgetID,
        },
      });

      // Temporary klaviyo events for  aletha health
      if (window.klaviyo && window.klaviyo.push) {
        logger.log('klaviyo push');
        const resp = window.klaviyo.push([
          'track',
          'Added to Cart',
          { AddedItemProductID: action.productId.toString() },
        ]);
        logger.log('klaviyo push response', resp);
      }
    } else {
      yield put({ type: ADD_TO_CART_ERROR, variantid: action.variant.id });
    }
  } catch (e) {
    logger.log(e);
    yield put({ type: ADD_TO_CART_ERROR, variantid: action.variant.id });
  } finally {
    shopifyCartMutex.release();
  }
}

export default function* addToCartWatcher() {
  yield takeEvery(ADD_TO_CART, addToCartWorker);
}
